module.exports = __webpack_public_path__ + "img/liftIcon17.d25b98f6.png";